class ParallaxBanner extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.mediaInner = null;
    this.ticking = false;
  }

  connectedCallback() {
    if (this.dataset.disableParallax === 'true') return;

    this.mediaInner = this.querySelector('[data-parallax-media]');
    if (!this.mediaInner) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.onScroll();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    window.requestAnimationFrame(() => {
      this.ticking = false;
      if (!this.mediaInner) return;

      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (rect.bottom < 0 || rect.top > viewportHeight) {
        this.mediaInner.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      const scrollProgress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const offset = (scrollProgress - 0.5) * 60;
      this.mediaInner.style.transform = `translate3d(0, ${offset}px, 0)`;
    });
  }
}

if (!customElements.get('parallax-banner')) {
  customElements.define('parallax-banner', ParallaxBanner);
}
